type ENV = {
  ACCOUNTS_PORTAL_URL: string;
  ACCOUNTS_URL: string;
  ALPHA_URL: string;
  CARDINAL_URL: string;
  CERBERUS_URL: string;
  CHARGING_STATION_URL: string;
  COLLIDE_URL: string;
  CONTAINER_DEPOT_URL: string;
  DEPLOY_SERVICE_URL: string;
  ENVIRONMENT: string;
  FLIGHT_LOG_URL: string;
  FORCE_MOBILE_VERIFY: string;
  INTERCOM_URL: string;
  OXIDE_URL: string;
  PS_DASHBOARD_URL: string;
  PS_DASHBOARD_DEFAULT: string;
  RECAPTCHA_V2_SITE_KEY: string;
  RECAPTCHA_V3_SITE_KEY: string;
  SOURCE_SERVICE_URL: string;
  STRIPE_PK: string;
  USER_EMAIL: string;
  USER_ID: string;
  USER_NAME: string;
  USER_ORG: string;
};

export const ENV: ENV = {
  ...((window as any).process.env as ENV)
};
